let task
export default {
    methods: {
        updateSwiper (key, data) {
            if (this[key].length && this[key].length !== data.length) {
                this[key] = []
                task = setTimeout(() => {
                    this[key] = data || []
                })
            } else {
                this[key] = data || []
            }
        }
    },
    destroyed () {
        task && clearTimeout(task)
    }
}
